// extracted by mini-css-extract-plugin
export var informationBlock = "style-module--informationBlock--yRQc9";
export var link = "style-module--link--ZUce2";
export var informationContainer = "style-module--informationContainer--L0cvu";